import { Component, ViewEncapsulation, ViewChild, Inject, OnInit, Output, EventEmitter, Input } from '@angular/core';
import {
	ToolbarService,
	DocumentEditorContainerComponent,
	WordExportService,
	DocumentEditorContainerModule
} from '@syncfusion/ej2-angular-documenteditor';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { DocumentViewerService } from 'src/app/services/document-viewer.service';
import { TypeDocument } from 'src/app/models/document-viewer';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { ActionDialogComponent } from '../action-dialog/action-dialog.component';
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component';
import { DestinationFolderDialogDesktopComponent } from '../destination-folder-dialog-desktop/destination-folder-dialog-desktop.component';
import { ActionSheetController } from '@ionic/angular';
import { BackButtonService } from '../../services/back-button.service';
import { NgClass, NgIf } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

/**
 * Document Editor Component
 */
@Component({
	selector: 'app-doc-viewer',
	templateUrl: './doc-viewer.component.html',
	styleUrls: ['./doc-viewer.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [ToolbarService, WordExportService],
	imports: [NgIf, MatProgressSpinnerModule, MatButtonModule, MatIconModule, DocumentEditorContainerModule, NgClass],
	standalone: true
})
export class DocViewerComponent implements OnInit {
	constructor(
		private documentViewerService: DocumentViewerService,
		public dialog: MatDialog,
		private snackBar: MatSnackBar,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<DocViewerComponent>,
		private actionSheetController: ActionSheetController,
		private backButtonService: BackButtonService
	) {}

	@Input('isMobile') isMobile: boolean = false;
	isLoading = false;
	@Input('name') name: any;
	@Input('id') id: any;
	@Input('document') document: any;
	@Input('jobId') jobId: any;
	@Input('haveChooseDestinationFolder') haveChooseDestinationFolder = false;
	parentId = null;
	doctype = 'doc';

	@Output('closed') closed = new EventEmitter<any>();

	@ViewChild('documenteditor', { static: false })
	public container: DocumentEditorContainerComponent;
	public culture = 'en-US';
	toolbarItems = [
		'Undo',
		'Redo',
		'Comments',
		'Image',
		'Table',
		'Hyperlink',
		'Bookmark',
		'TableOfContents',
		'Header',
		'Footer',
		'PageSetup',
		'PageNumber',
		'Break',
		'Find',
		'LocalClipboard',
		'RestrictEditing'
	];
	heightWindow = window.innerHeight - 66 + 'px';

	ngOnInit() {
		// this.name = "Contract for Repairs/Work Athorization.docx";
		// this.id = 1447;
	}

	onCreate(): void {
		//Hide new and open button
		this.container.toolbarModule.toolbar.hideItem(0, true);
		this.container.toolbarModule.toolbar.hideItem(1, true);
		this.container.toolbarModule.toolbar.hideItem(2, true);
		//end
		if (this.container.documentEditor.isDocumentLoaded) {
			this.isLoading = true;
			this.container.serviceUrl = '';
			const data = {
				type: TypeDocument.JobDocument,
				id: this.id,
				doctype: this.doctype
			};
			const ref = this;
			this.documentViewerService.OpenDoc(data).subscribe(
				(sfdt: string) => {
					this.isLoading = false;
					ref.container.documentEditor.open(sfdt);
					if (this.isMobile) {
						this.container.showHidePropertiesPane(false);
						setTimeout(() => {
							this.container.documentEditor.fitPage('FitPageWidth');
						}, 50);
					}
				},
				(error) => {
					this.isLoading = false;
					this.snackBar.open(error.error.Message);
				}
			);
		}
	}

	onDocumentChange(): void {}

	cancel() {
		const actionDialogRef = this.dialog.open(ActionDialogComponent, {
			disableClose: true,
			data: {
				title: 'Discard Changes',
				content: 'Are you sure you want to discard the changes you have made to this document? Your action cannot be undone.',
				buttons: [
					{
						title: 'Cancel',
						color: '#41404D',
						action: () => {
							actionDialogRef.close();
						}
					},
					{
						title: 'Discard',
						color: '#BC4630',
						action: () => {
							// this.dialogRef.close(true);
							actionDialogRef.close(true);
						}
					}
				]
			}
		});

		actionDialogRef.afterClosed().subscribe((rs) => {
			if (rs) {
				this.closed.emit(false);
			}
		});
	}

	save() {
		const actionDialogRef = this.dialog.open(ActionDialogComponent, {
			disableClose: true,
			data: {
				title: 'Save Changes',
				content: 'Confirm the changes you have made to this document.',
				buttons: [
					{
						title: 'Cancel',
						color: '#41404D',
						action: () => {
							actionDialogRef.close();
						}
					},
					{
						title: 'Save',
						color: '#3E92CC',
						action: () => {
							this.isLoading = true;
							const blob = this.container.documentEditor.saveAsBlob('Docx').then((file) => {
								const formData: FormData = new FormData();
								formData.append('uploadFile', file);
								formData.append('id', this.id);
								formData.append('type', TypeDocument.JobDocument.toString());

								this.documentViewerService.Save(formData).subscribe(
									(rs) => {
										// this.dialogRef.close(true);
										this.isLoading = false;
										this.closed.emit(true);
									},
									(error) => {
										this.isLoading = false;
										this.snackBar.open(error.error.Message);
									}
								);
							});
							actionDialogRef.close();
						}
					}
				]
			}
		});
	}

	saveDocAsPdf() {
		if (this.haveChooseDestinationFolder) {
			const dialogRef = this.dialog.open(DestinationFolderDialogDesktopComponent, {
				width: '800px',
				maxHeight: '182px',
				panelClass: 'destination-folder-dialog-desktop',
				data: {
					document: this.document
				}
			});

			dialogRef.afterClosed().subscribe((rs) => {
				if (rs) {
					// destination folder
					// rs: is Parent_Id of document
					this.parentId = rs;
					this.saveDocument();
				}
			});
		} else {
			this.saveDocument();
		}
	}

	saveDocument() {
		const blob = this.container.documentEditor.saveAsBlob('Docx').then((file) => {
			const formData: FormData = new FormData();
			formData.append('uploadFile', file);
			formData.append('id', this.id);
			formData.append('type', TypeDocument.JobDocument.toString());

			this.documentViewerService.Save(formData).subscribe(
				(rs) => {
					// this.dialogRef.close(true);
					this.isLoading = false;
					this.saveAsPdf();
				},
				(error) => {
					this.isLoading = false;
					this.snackBar.open(error.error.Message);
				}
			);
		});
	}

	KEY_CONVERT_TO_PDF_MOBILE = 'pdfmobile';
	saveAsPdf() {
		this.isLoading = true;
		const data = {
			type: TypeDocument.JobDocument,
			id: this.id,
			doctype: this.doctype,
			parentId: this.parentId,
			jobId: this.jobId
		};

		if (this.isMobile) {
			this.documentViewerService.SaveAsPdfMobile(data).subscribe(
				(rs: any) => {
					this.isLoading = false;
					let result = {
						key: this.KEY_CONVERT_TO_PDF_MOBILE,
						document: rs
					};
					this.closed.emit(result);
				},
				(error) => {
					this.isLoading = false;
					const actionDialogRef = this.dialog.open(ActionDialogComponent, {
						disableClose: true,
						data: {
							title: 'Convert failed',
							content: error.error.Message,
							buttons: [
								{
									title: 'Cancel',
									color: '#41404D',
									action: () => {
										actionDialogRef.close();
									}
								},
								{
									title: 'Try Again',
									color: '#3E92CC',
									action: () => {
										this.saveAsPdf();
									}
								}
							]
						}
					});
				}
			);
		} else {
			this.documentViewerService.SaveAsPdf(data).subscribe(
				(rs: any) => {
					this.isLoading = false;
					// if(this.isMobile) {
					//     this.closed.emit(this.KEY_CONVERT_TO_PDF_MOBILE, );
					// } else {
					this.closed.emit(true);
					this.dialog.open(PdfViewerComponent, {
						maxWidth: '100vw',
						maxHeight: '100vh',
						height: '100%',
						panelClass: 'pdf-popup',
						width: '100%',
						data: {
							id: this.id,
							pdfSrc: rs.File_Url,
							name: rs.File_Name
						}
					});
					// }
				},
				(error) => {
					this.isLoading = false;
					const actionDialogRef = this.dialog.open(ActionDialogComponent, {
						disableClose: true,
						data: {
							title: 'Convert failed',
							content: error.error.Message,
							buttons: [
								{
									title: 'Cancel',
									color: '#41404D',
									action: () => {
										actionDialogRef.close();
									}
								},
								{
									title: 'Try Again',
									color: '#3E92CC',
									action: () => {
										this.saveAsPdf();
									}
								}
							]
						}
					});
				}
			);
		}
	}

	public saveDocumentSheet: HTMLIonActionSheetElement;
	async openSaveDocument() {
		this.saveDocumentSheet = await this.actionSheetController.create({
			buttons: [
				{
					text: 'Save Document',
					handler: () => {
						this.save();
					}
				},
				{
					text: 'Save as PDF',
					handler: () => {
						this.saveDocAsPdf();
					}
				},
				{
					text: 'Cancel',
					role: 'cancel',
					handler: () => {}
				}
			]
		});

		await this.saveDocumentSheet.present();
		this.backButtonService.registerDialog(this.saveDocumentSheet, true);
	}
}
